module.exports = __webpack_public_path__ + "static/media/covid_qr_p2_1.c7476824.gif";